<template>
  <!-- width: '90vw', -->
  <!-- top: `${heightColumnNavProps}px`, -->
  <div
    :style="{
      height: `${heightColumnDailyProps - 20}px`,
      top: adjustTop,
      width: isShrink ? '100%' : '100.12%',
      position: 'sticky',
    }"
    class="weekly-nav sticky-left is-clickable"
    @click="handleAccordionProps(indexWeekProps)"
  >
    <div
      class="weekly-title flex-center-vertical color-white"
    >
      <div class="title-week-wrapper is-flex">
        <p>
          <span class="averta-bold">
            {{formatMonth({start: itemWeekProps.start_date, end: itemWeekProps.end_date})}} | Minggu Ke {{ itemWeekProps.week }}
          </span>
          <span class="averta-regular ml-3">
            {{formatDate(itemWeekProps.start_date)}} - {{formatDate(itemWeekProps.end_date)}}
          </span>
        </p>
        <!-- <div class="flex-center is-relative pr-5 open-list-wrapper">
          <p>{{indexAccordionWeekProps.includes(indexWeekProps) ? 'Buka' : 'Tutup'}} Daftar</p>
          <div
            class="collapse-wrapper flex-center"
            :class="{'close': indexAccordionWeekProps.includes(indexWeekProps)}"
          >
            <CollapseIcon color="#fff" />
          </div>
        </div> -->
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import { formatDateHelper } from '@/helpers'
import { CollapseIcon } from '@/components/icons'

export default {
  name: 'AccordionWeeklyProgress',
  components: {
    // eslint-disable-next-line vue/no-unused-components
    CollapseIcon
  },
  props: {
    itemWeekProps: {
      type: Object
    },
    indexWeekProps: {
      type: Number
    },
    heightColumnDailyProps: {
      type: Number
    },
    heightColumnNavProps: {
      type: Number
    },
    widthWeekAccordionProps: {
      type: Number
    },
    indexAccordionWeekProps: {
      type: Array
    },
    handleAccordionProps: {
      type: Function
    },
    topAccordion: {
      type: String
    },
    isShrink: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    adjustTop () {
      return this.topAccordion
    }
  },
  methods: {
    formatDate (date, format) {
      if (!date) return ''
      return formatDateHelper({ date, format })
    },
    formatMonth (props = {}) {
      const { start, end } = props
      if (!start && !end) return '-'
      const formatStart = moment(start).format('MMMM YYYY')
      const formatEnd = moment(end).format('MMMM YYYY')

      if (formatStart === formatEnd) return formatStart

      return `${formatStart} - ${formatEnd}`
    }
  }
}
</script>

<style scoped lang="scss">
@import "@/scss/_variables.scss";

.weekly-nav {
  display: flex;
  align-items: center;
  background: linear-gradient(264.37deg, #4BBEFF 1.66%, #594BFF 120.13%);
  border: 1px solid $color-grey-10;
  z-index: 6;
}

.weekly-title {
  position: sticky;
  left: 11px;
  display: flex;
  // justify-content: space-between;
  align-items: center;
  width: 100%;
  padding-left: 10px;
}

.collapse-wrapper {
  transition: 0.2s all ease-in-out;
  transform: rotate(180deg);
  margin-left: 20px;
}

.collapse-wrapper.close {
  transform: rotate(0deg);
}

.title-week-wrapper {
  position: sticky;
  left: 11px;
}

.open-list-wrapper {
  left: 86vw;
}
</style>
